module.exports = __webpack_public_path__ + "static/media/box-s.09b1b034.png";